import React from 'react';
import clsx from 'clsx';
import { is } from '../../../services';
import { getColorClassName } from '../../../objects';
import { hashClass } from '../../../helpers';
import { useTrilogyContext } from '../../../context';
/**
 * Table TR Component
 * @param children {ReactNode}
 * @param expandable {boolean} Lines can display additional information
 * @param expanded {boolean} An unfolded line will also receive class
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 * @param expansion {boolean} Is expansion
 * @param onClick {ClickEvent} On click event
 * @param color {TrilogyColor} Higlight color
 * @param ref {React.RefObject<HTMLTableRowElement>} Ref of the row
 */
const TableTr = ({ className, expandable, expanded, expansion, color, ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx(className, expandable && is('expandable'), expanded && is('expanded'), expansion && is('expansion'), color && getColorClassName(color)));
    return React.createElement("tr", { className: classes, ...others });
};
export default TableTr;
//# sourceMappingURL=TableTr.js.map